import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const {
  animationLong,
  animationShort,
  white,
  primaryRed,
  primaryBlack,
  failureScreenButtonGradient,
  fontMBank,
} = styles;

export const PaymentInitFailScreenButtonWrapper = styled.div`
  .failure-screen__recovery-payment-button {
    @media (max-width: 992px) {
      width: 100%;
      display: block;
    }
  }
`;

export const PaymentInitFailScreenContainer = styled.div<{ isLoading: boolean; height: number }>`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 3.3125rem;

  ${props =>
    props.isLoading &&
    ` padding: 0;
      height: ${props.height}px;
  `}
  .failure-screen__recovery-payment-button {
    display: inline-block;

    @media (max-width: 992px) {
      width: 100%;
      display: block;
    }
  }
`;

export const PaymentInitFailScreenWrapper = styled.div`
  ${fadeInAnimationShort};
  animation: ${animationShort};

  @media (max-width: 992px) {
    max-width: 14.125rem;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const PaymentInitFailScreenPageTitle = styled.div`
  font-size: 1.6rem;
  margin: 0 auto;
  line-height: 2.5rem;
  color: ${primaryRed};
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const PaymentInitFailScreenIcon = styled.div`
  ${fadeInAnimationLong};
  animation: ${animationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 0.5rem;
`;

export const PaymentInitFailScreenMessageTitle = styled.div`
  font-size: 1rem;
  line-height: 1.5;
  font-weight: bold;
  color: ${primaryBlack};
  margin-bottom: 1.25rem;
`;

export const PaymentInitFailScreenMessageContent = styled(PaymentInitFailScreenMessageTitle)`
  font-weight: normal;
  margin-bottom: 2.25rem;
`;

export const PaymentInitFailScreenBackButton = styled.button`
  position: relative;
  white-space: nowrap;
  border-radius: 0.6875rem;
  margin-left: 2rem;
  background-image: ${failureScreenButtonGradient};
  border-radius: 0.6875rem;
  color: ${white};
  padding: 0.625rem 4.5rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  font-family: ${fontMBank};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @media (max-width: 992px) {
    width: 100%;
    margin: 0.625rem 0;
    white-space: normal;
    padding: 0.625rem 0.5rem;
  }
`;
